import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	categoriesTitle: {
		fontWeight: theme.typography.fontWeightBold
	},
	categoriesText: {
		cursor: 'pointer',
		'&:hover': {
			color: theme.palette.text.secondary
		}
	},
	categoriesTextSelected: {
		color: theme.palette.secondary.main,
		fontWeight: theme.typography.fontWeightBold
	}
}));

export const useListItemStyles = makeStyles(theme => ({
	root: {
		paddingTop: theme.spacing(0.5),
		paddingBottom: theme.spacing(0.5)
	}
}));
